export default __webpack_public_path__ + "static/media/selecta_main_mobile.c8a650c0.jpg";